import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

/**
 * Landing for a signed-in user who has no active profile yet — e.g. their
 * invite created the auth user but an admin hasn't activated them, or they were
 * deactivated. They have a valid session but no access to any protected route.
 */
export function AccessPending() {
  const { user, profile, loading, signOut } = useAuth();

  if (loading) return <div className="centered">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (profile && profile.is_active) return <Navigate to="/dashboard" replace />;

  return (
    <div className="auth-card">
      <h1>Access pending</h1>
      <p className="muted">
        You&rsquo;re signed in as <strong>{user.email}</strong>, but your account isn&rsquo;t active
        yet. An administrator needs to grant you access. Please check back later or contact your
        admin.
      </p>
      <button type="button" onClick={() => void signOut()}>
        Sign out
      </button>
    </div>
  );
}
